/* roll_back.icon.svg.js */

module.exports = {
    icon: `    
           <svg viewBox="0 0 15.5 16" preserveAspectRatio="none">
            <g>
                <path class="foreground-gl" d="M10.9,15.3c-3.9,1.7-8.5,0-10.2-3.9C0.1,10.2-0.1,8.9,0,7.5C0.1,7,0.6,6.6,1.1,6.7C1.6,6.7,2,7.2,2,7.7
                    c-0.1,1,0.1,2,0.5,2.9c1.3,2.9,4.7,4.2,7.7,2.9s4.2-4.7,2.9-7.7c-0.2-0.5,0-1.1,0.5-1.3c0.5-0.2,1.1,0,1.3,0.5
                    C16.5,9,14.8,13.6,10.9,15.3z"/>
                <g>
                    <path class="foreground-gl" d="M6.9,0l6.9,1.4c0.6,0.1,0.7,0.9,0.2,1.2l-2.1,1c-0.2,0.1-0.3,0.3-0.3,0.5l-0.1,2.3c0,0.6-0.8,0.8-1.1,0.3
                        L6.3,1C6,0.5,6.4-0.1,6.9,0z"/>
                </g>
            </g>
            </svg>
        `
};
